import { MaterialBottomTabNavigationProp } from '@react-navigation/material-bottom-tabs';
import { useNavigation, useRoute } from '@react-navigation/native';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { Text } from 'react-native-paper';
import { BaseParamList } from '../types';

export default function NotFoundScreen() {
  const navigation =
    useNavigation<MaterialBottomTabNavigationProp<BaseParamList>>();
  const route = useRoute();

  return (
    <View style={styles.container}>
      <Text style={styles.title}>This screen doesn't exist. {route.path}</Text>
      <TouchableOpacity
        onPress={() => navigation.jumpTo('Root', { screen: 'Home' })}
        style={styles.link}
      >
        <Text style={styles.linkText}>Go to home screen!</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  link: {
    marginTop: 15,
    paddingVertical: 15,
  },
  linkText: {
    fontSize: 14,
    color: '#2e78b7',
  },
});
